import { inject, Injectable } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map, Observable, tap } from 'rxjs';

import { ApplicationSettingsService } from '../../application-settings/service/application-settings.service';
import { NavigationService } from '../../navigation/service/navigation.service';

@Injectable({ providedIn: 'root' })
export class GiftCardsGuard {
  constructor(
    private readonly applicationSettingsService: ApplicationSettingsService,
    private readonly navigationService: NavigationService,
  ) {}

  canActivate(): Observable<boolean> {
    return this.applicationSettingsService.applicationSettings$.pipe(
      map((applicationSettings) => applicationSettings.onlineGiftCardActive),
      tap((onlineGiftCardActive) => {
        if (!onlineGiftCardActive) {
          this.navigationService.navigateTo404Page();
        }
      }),
    );
  }
}

export const canActivate: CanActivateFn = () =>
  inject(GiftCardsGuard).canActivate();
